import { Service } from '../store/service/Service';
import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'girko-header',
  template: `
    <nav>
      <div class="hamburger" *ngIf="service?.active" (click)="hamburgerClick.emit()">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="container" [class.active]="service?.active">
        <girko-logo></girko-logo>
        <a *ngIf="service" class="back-link" (click)="goToProfile.emit(service)">
          {{'Мій профіль' | translate}} &rarr;
        </a>
      </div>
    </nav>
  `,
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @Input() service: Service;

  @Output() goToProfile = new EventEmitter<Service>();
  @Output() hamburgerClick = new EventEmitter<any>();
}
